module.exports = __webpack_public_path__ + "img/weixin_logo.b1a430cd.png";